import React from 'react';
import { Box } from 'lmc-ui-library';
import { CaseDetails } from '../../CaseDetailsPage.types';
import { SubPageTemplate } from '../../partials';
import css from './TIORepaymentStrategy.module.scss';
import RepaymentStrategyForm from './RepaymentStrategyForm';
import { RepaymentStrategy } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';
import { CaseId } from 'modules/cm/api/cases/types';

interface Props {
  caseId: CaseId;
  resources: CaseDetails['resources'];
  initialRepaymentStrategy: RepaymentStrategy;
  repaymentStrategy: RepaymentStrategy;
}

const TIORepaymentStrategy: React.FC<Props> = ({ caseId, initialRepaymentStrategy, repaymentStrategy }) => {
  return (
    <SubPageTemplate title="Repayment strategy">
      <Box className={css.wrapper}>
        <Box.Content>
          <h2>Repayment strategy calculation</h2>
          <p>
            This section applies to the Term interest only mortgage. You must have in place a suitable strategy for
            repaying the loan at the end of the term. You can use more than one repayment strategy.
          </p>
          <p>Please select at least one repayment strategy</p>

          <RepaymentStrategyForm
            caseId={caseId}
            initialRepaymentStrategy={initialRepaymentStrategy}
            repaymentStrategy={repaymentStrategy}
          />
        </Box.Content>
      </Box>
    </SubPageTemplate>
  );
};

export default TIORepaymentStrategy;
